(function ($) {
  "use strict";
  //toggle for product page hide show pay flex and payjustnow
  $(document).ready(function ($) {
    $("body").on("click", ".pay_after h2", function () {
      $(".pay_after_content").slideToggle();
      $(".pay_after h2").toggleClass("active");
    });
  });
})(jQueryTheme);
